import React, { useState } from "react";
import {
  createStyles,
  Grid,
  Hidden,
  makeStyles,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import _ from "lodash";

import SortingMethod from "../../../../components/common/SortingMethod/SortingMethod";
import WithLoading from "../../../../utils/WithLoading";
import CardCommon from "../../../../components/card/CardCommon";
import StockItemInfoNode from "./StockItemInfoNode";

export interface OrdersHeaderProps {
  disableButton: any;
  isLoading: any;
  locationSelectorList: any;
  handleOnClickText: any;
  handleOpenEditStockItemsModal: any;
  handleOpenEditMapProductsItemsModal: any;
  handleOpenEdtSupplierToTheStockItems: any;
  selectedDepartmentId: any;
  searchName: any;
  registerElementWithTitle: any;
  stockItemGroupDepartmentNodeInSelectorInitial: any;
  stockItemGroupDepartmentNodeInSelector: any;
  activeGroupId: any;
  searchNameTab: any;
}

const useStyles = makeStyles((theme: any) =>
  createStyles({
    headerItemStyle: {
      display: "flex",
      placeItems: "center",
      paddingLeft: "14px",
    },
    headerItemStyleEndColumn: {
      display: "flex",
      placeItems: "center",
      justifyContent: "end",
      paddingRight: "14px",
    },
    headerFirstItemStyle: {
      display: "flex",
      justifyContent: "flex-start",
      placeItems: "center",
      paddingLeft: "14px",
    },
    headerItemStyles: {
      fontSize: "12px",
      fontWeight: "bold",
      [theme.breakpoints.down("sm")]: {
        fontSize: "11px",
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: "9px",
      },
      color: theme.palette.custom["orange"].contrastText,
    },
  }),
);

/* This is order Table header page. In addition, Until the required data for the order 
   table is received from the API call, this will show the loading of the skeleton. */
const StockItemsHeader: React.FunctionComponent<OrdersHeaderProps> = ({
  disableButton,
  isLoading,
  locationSelectorList,
  handleOpenEditStockItemsModal,
  handleOpenEditMapProductsItemsModal,
  handleOpenEdtSupplierToTheStockItems,
  selectedDepartmentId,
  searchName,
  registerElementWithTitle,
  stockItemGroupDepartmentNodeInSelectorInitial,
  stockItemGroupDepartmentNodeInSelector,
  activeGroupId,
  searchNameTab,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpenDepartmentList = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const hasWindow = typeof window !== "undefined";
  /* Close the UI showing the list of categories. */
  const handleClose = () => {
    setAnchorEl(null);
  };
  const theme = useTheme();
  const matchesLg = useMediaQuery(theme.breakpoints.down("md"));
  const classes = useStyles();
  return (
    <>
      <div
        style={matchesLg ? { marginTop: "220px" } : { marginTop: "160px" }}
      ></div>
      <Hidden smDown>
        <CardCommon backgroundColor={"table_header_background"}>
          <Grid container style={{ minHeight: "36px" }}>
            <Grid item xs={2} className={classes.headerFirstItemStyle}>
              <Typography
                align="left"
                style={{ fontWeight: "bolder", textTransform: "none" }}
                className={classes.headerItemStyles}
              >
                Group
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.headerItemStyle}>
              <Typography
                align="left"
                style={{ fontWeight: "bolder", textTransform: "none" }}
                className={classes.headerItemStyles}
              >
                Department
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.headerItemStyle}>
              <Typography
                align="left"
                style={{ fontWeight: "bolder", textTransform: "none" }}
                className={classes.headerItemStyles}
              >
                Name
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.headerItemStyle}>
              <Typography
                align="left"
                style={{ fontWeight: "bolder", textTransform: "none" }}
                className={classes.headerItemStyles}
              >
                SKU
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.headerItemStyle}>
              <Typography
                align="left"
                style={{ fontWeight: "bolder", textTransform: "none" }}
                className={classes.headerItemStyles}
              >
                Barcode
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.headerItemStyleEndColumn}>
              <Typography
                align="left"
                style={{ fontWeight: "bolder", textTransform: "none" }}
                className={classes.headerItemStyles}
              >
                Actions
              </Typography>
            </Grid>
          </Grid>
        </CardCommon>
      </Hidden>
      <Grid container style={{ marginTop: "1px" }}>
        {!_.isEmpty(stockItemGroupDepartmentNodeInSelector) ? (
          stockItemGroupDepartmentNodeInSelector.map(
            (group: any, index: number) =>
              (activeGroupId === index || searchNameTab) &&
              group.stockDepartmentId.map((department: any) =>
                department.item.map((item: any) => (
                  <Grid item xs={12}>
                    <div
                      id={department.name}
                      style={{ position: "sticky", zIndex: 0 }}
                    >
                      <Grid
                        item
                        xs={12}
                        style={{ placeItems: "center", marginTop: "4px" }}
                      >
                        <StockItemInfoNode
                          nodeData={item}
                          locationSelectorList={locationSelectorList}
                          handleOpenEditStockItemsModal={
                            handleOpenEditStockItemsModal
                          }
                          handleOpenEditMapProductsItemsModal={
                            handleOpenEditMapProductsItemsModal
                          }
                          handleOpenEdtSupplierToTheStockItems={
                            handleOpenEdtSupplierToTheStockItems
                          }
                          handleOpenDepartmentList={handleOpenDepartmentList}
                          anchorEl={anchorEl}
                          handleClose={handleClose}
                          departmentName={department}
                          groupName={group.name}
                          registerElementWithTitle={registerElementWithTitle}
                        />
                      </Grid>
                    </div>
                  </Grid>
                )),
              ),
            // department.map((data: any) =>
            //   data.map((item: any) => (
            //     <Grid item xs={12}>
            //       <div
            //         ref={(ref) => registerElementWithTitle(data.id, ref)}
            //         id={data.name}
            //         style={
            //           index > 0
            //             ? { position: "sticky", zIndex: 0 }
            //             : { position: "sticky", zIndex: 0 }
            //         }
            //       >
            //         <Grid
            //           item
            //           xs={12}
            //           style={{ placeItems: "center", marginTop: "4px" }}
            //         >
            //           <StockItemInfoNode
            //             nodeData={item}
            //             locationSelectorList={locationSelectorList}
            //             numberOfLocations={numberOfLocations}
            //             handleOpenEditStockItemsModal={
            //               handleOpenEditStockItemsModal
            //             }
            //             handleOpenEditMapProductsItemsModal={
            //               handleOpenEditMapProductsItemsModal
            //             }
            //             handleOpenEdtSupplierToTheStockItems={
            //               handleOpenEdtSupplierToTheStockItems
            //             }
            //             handleOpenDepartmentList={handleOpenDepartmentList}
            //             anchorEl={anchorEl}
            //             handleClose={handleClose}
            //             departmentName={department}
            //             registerElementWithTitle={registerElementWithTitle}
            //           />
            //         </Grid>
            //       </div>
            //     </Grid>
            //   )),
            // ),
          )
        ) : (
          <div style={{ width: "100%", margin: "auto", marginTop: "5%" }}>
            <Typography variant="h4" align="center">
              No Stock Items available.
            </Typography>
          </div>
        )}
      </Grid>
    </>
  );
};

export default WithLoading(StockItemsHeader);
